export default __webpack_public_path__ + "static/media/h-blue.567fb4aa.png";